// extracted by mini-css-extract-plugin
module.exports = {"clickHandler":"popup_clickHandler__2U3Fy","reference":"popup_reference__VNcKI","arrow":"popup_arrow__w8MrR","popper":"popup_popper__rQ1M8","fade-in":"popup_fade-in__YCzWe"};